/* eslint-disable react/prop-types, react/jsx-first-prop-new-line, prefer-template */
import React from 'react';
import classnames from 'classnames';
import { StyleSheet, css } from 'aphrodite';
import { ROUNDBOX_INNER_PADDING } from 'es6/core/styles/sizes';
import {
  ROUNDBOX_BACKGROUND_COLOR,
  ROUNDBOX_BORDER_COLOR,
} from 'es6/core/styles/colors';

export default function RoundBox({ children, padded }) {
  return (
    <div className={classnames(css(styles.roundbox),
                               { [css(styles.padded)]: padded })}>
      {children}
    </div>
  );
}

const styles = StyleSheet.create({
  roundbox: {
    border: `1px solid ${ROUNDBOX_BORDER_COLOR}`,
    borderRadius: '5px',
    backgroundColor: ROUNDBOX_BACKGROUND_COLOR,
  },
  padded: {
    padding: ROUNDBOX_INNER_PADDING + 'px',
  },
});
